export type Locale = "en" | "zh";

export interface Translations {
  nav: {
    appStore: string;
    iosChn: string;
    googlePlay: string;
    macos: string;
    windows: string;
    androidChn: string;
  };
  hero: {
    title: string;
    subtitle: string[];
    desc: string;
  };
  download: {
    title: string;
    notifInstructions: string;
  };
  featuresHdr: {
    title: string;
  };
  chats: {
    bannerLabel: string;
    subtitle: string;
    name: string;
    desc: string;
  };
  discovery: {
    bannerLabel: string;
    subtitle: string;
    name: string;
    desc: string;
    postText: string[];
  };
  groups: {
    discover: string;
    bannerLabel: string;
    name: string;
    desc: string;
  };
  security: {
    bannerLabel: string;
    subtitle: string;
    name: string;
    desc: string;
  };
}

const en: Translations = {
  nav: {
    appStore: "App Store",
    iosChn: "iOS (中国)",
    googlePlay: "Google Play",
    macos: "MacOS",
    windows: "Windows",
    androidChn: "Android (中国)",
  },
  hero: {
    title: "All-in-one platform",
    subtitle: ["Effortless Chat,", "Seamless Connection,", "Unlimited Discovery."],
    desc: "VennChat – is a dynamic social media platform that connects users, leading to meaningful interactions and relationships. By collaborating with trusted application publishers.",
  },
  download: {
    title: "Choose the way to Download",
    notifInstructions: "Push notification settings instructions",
  },
  featuresHdr: {
    title: "What things you could enjoy\nwith Vennchat",
  },
  chats: {
    bannerLabel: "Private messaging",
    subtitle: "Efficient chat service",
    name: "Chats",
    desc: "Vennchat – Effortlessly connect with friends and family in real-time. Share links, photos, videos, and even voice recordings.",
  },
  discovery: {
    bannerLabel: "Discover Communities",
    subtitle: "Explore captivating posts",
    name: "Discovery",
    desc: "Stay connected with friends, receive real-time updates, explore engaging content, and enjoy a seamless browsing experience. Enjoy captivating posts from your friends in a single, convenient location.",
    postText: ["Connecting with", "your social circle", "with posting"],
  },
  groups: {
    discover: "Discover new communities",
    bannerLabel: "Seamless communication",
    name: "Groups",
    desc: "Discover and create groups based on your interests, then connect with like-minded people in safe, private communities. Group admins can invite or remove members, assign roles, mute users, and share secure links. Enjoy full control with customizable notifications, chat colors, wallpapers, and disappearing messages for a more personalized social experience.",
  },
  security: {
    bannerLabel: "User security",
    subtitle: "Personalize your profile",
    name: "Profile",
    desc: "Customize your personal profile page to reflect your unique personality, style, and accomplishments. Take control of your personal information and privacy settings to ensure a safe and secure online presence.",
  },
};

const zh: Translations = {
  nav: {
    appStore: "苹果商店",
    iosChn: "苹果（中国）",
    googlePlay: "谷歌商店",
    macos: "MacOS",
    windows: "Windows",
    androidChn: "安卓（中国）",
  },
  hero: {
    title: "一站式社交平台",
    subtitle: ["畅聊无阻，", "连接无缝，", "探索无限。"],
    desc: "VennChat 是一款充满活力的社交媒体平台，将用户紧密相连，促成有意义的互动与关系。我们与值得信赖的应用发行商深度合作。",
  },
  download: {
    title: "选择下载方式",
    notifInstructions: "推送通知设置说明",
  },
  featuresHdr: {
    title: "探索 VennChat\n带给你的精彩体验",
  },
  chats: {
    bannerLabel: "私信功能",
    subtitle: "高效的聊天服务",
    name: "聊天",
    desc: "VennChat – 随时随地与亲友实时连接。轻松分享链接、照片、视频，甚至语音消息。",
  },
  discovery: {
    bannerLabel: "发现社区",
    subtitle: "探索精彩内容",
    name: "发现",
    desc: "与好友保持联系，实时获取动态，探索精彩内容，享受流畅的浏览体验。在同一个地方尽览好友发布的精彩帖子。",
    postText: ["与你的社交圈", "保持连接，", "随时发布动态"],
  },
  groups: {
    discover: "发现新社区",
    bannerLabel: "无缝沟通",
    name: "群组",
    desc: "根据兴趣发现或创建群组，在安全私密的社区中结交志同道合的人。群管理员可邀请或移除成员、分配角色、禁言用户并分享安全链接。支持自定义通知、聊天颜色、壁纸及阅后即焚消息，打造专属社交体验。",
  },
  security: {
    bannerLabel: "用户安全",
    subtitle: "个性化你的主页",
    name: "个人资料",
    desc: "自定义个人主页，展现你独特的个性、风格与成就。掌控个人信息与隐私设置，确保安全的在线形象。",
  },
};

export const translations: Record<Locale, Translations> = { en, zh };
